/**************************************************
 * Nombre:       Item_Categoria
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Collapse, Grid, Typography} from "@mui/material";
import {Add, FiberManualRecord, Remove} from '@mui/icons-material'
import {useContext, useEffect, useState} from "react";
import {theme} from "../../../Tema";
import {contexData} from "../../../App";
import img_def from '../../../Recursos/img_cat_defecto.png'
import {useNavigate} from "react-router-dom";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";

const Item_Categoria = ({item, escogido, setEscogido}) => {
    const {sCell} = useResponsive()
    const cData = useContext(contexData)
    const navigate = useNavigate()
    const [subCasts, setSubCats] = useState([])
    const [isSelec, setIsSelec] = useState(false)


    useEffect(() => {
        setIsSelec(escogido.nombre === item.nombre)
    }, [escogido])

    useEffect(() => {

        if (item) {
            setSubCats(item.subCat ? item.subCat : [])
        }


    }, [item]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}

        >

            <Grid
                onClick={() => setEscogido(item)}
                container size={{xs: 12, sm: 12, md: 12}}>
                <Grid
                    container
                    justifyContent={'space-between'}
                    alignItems={'center'}
                    size={12}
                    sx={{cursor: 'pointer', py: 0.4}}
                >


                    <Typography
                        sx={{
                            transition: 'all .2s ease-in-out',
                            fontWeight: 400,
                            fontSize: 18,
                            color: isSelec ? theme.palette.primary.main : '#000000',
                            '&:hover': {
                                color: theme.palette.primary.main
                            }
                        }}
                    >
                        <span><img src={item.img ? item.img : img_def} width={18} height={'auto'}
                                   style={{marginTop: 3, marginBottom: -3, marginRight: 4}}/></span>

                        {item.nombre}</Typography>

                    {isSelec ?
                        <Remove sx={{width: 16, height: 16, fill: '#00000090'}}/>
                        :
                        <Add sx={{width: 16, height: 16, fill: '#00000090'}}/>
                    }


                </Grid>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Collapse in={isSelec}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}} sx={{pl: 3}}>

                        {subCasts.map((it, index) => {
                            return (
                                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                                    <Typography
                                        onClick={() => {
                                            navigate('/')
                                            cData.setSubCatEscogida(it.nombre)
                                            cData.setIconoCat(item.img)
                                            if (sCell) cData.setOpenCategorias(false)
                                        }
                                        }
                                        sx={{
                                            transition: 'all .2s ease-in-out',
                                            fontSize: 16,
                                            borderBottom: 2,
                                            borderColor: '#00000000',
                                            cursor: 'pointer',
                                            '&:hover': {
                                                borderColor: theme.palette.primary.main,
                                            },
                                            color: cData.subCatEscogida === it.nombre ? theme.palette.primary.main : '#000'
                                        }}
                                    ><span style={{marginTop: 1, paddingRight: 5}}><FiberManualRecord
                                        sx={{
                                            height: 8,
                                            width: 8,
                                            fill: cData.subCatEscogida === it.nombre ? theme.palette.primary.main : '#00000090'
                                        }}/></span>
                                        {it.nombre}</Typography>
                                </Grid>
                            )
                        })}

                    </Grid>
                </Collapse>
            </Grid>

        </Grid>
    )

}
export default Item_Categoria

